module.exports = __webpack_public_path__ + "img/Group 7.120a16d3.png";